import clip from 'text-clipper'

class ReadMore {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._maxChar = parseInt(elem.dataset.readMore)
        this._content = elem.innerHTML
    }

    onInit () {
        let charCount = this._content.length
        if (charCount > this._maxChar) {
            // let truncatedContent = this.strip(this._content.split(' ').splice(0, this._maxChar).join(' '))
            let truncatedContent = clip(this._content, this._maxChar, { html: true })

            const customContentContainer = document.querySelector('[data-read-more-short]')
            if (customContentContainer) {
                if (customContentContainer.innerHTML.length > 0) {
                    truncatedContent = customContentContainer.innerHTML
                }
            }

            this._elem.innerHTML = ''

            this._elem.innerHTML =
            `
            <div class="js-read-more--truncated active">${truncatedContent} <span class="js-read-more__cta">Find out more</span></div>
            <div class="js-read-more--full">${this._content}</div>
            <noscript>${this._content}</noscript>
            `
            let button = this._elem.querySelector('.js-read-more__cta')
            if (button) {
                button.addEventListener('click', () => { this.handleClick() })
            }
        }
    }
    handleClick () {
        let truncated = this._elem.querySelector('.js-read-more--truncated')
        let full = this._elem.querySelector('.js-read-more--full')
        if (truncated && full) {
            truncated.classList.remove('active')
            full.classList.add('active')
        }
    }
    strip (html) {
        let doc = new DOMParser().parseFromString(html, 'text/html')
        return doc.body.textContent || ''
    }
}

export default ReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js